import { AxiosInstance } from 'axios';

import { IBookmarkAsset } from '@mais-retorno-front/models/bookmark-asset.model';
import { ICatchIssueUseCase } from '../catch-issue.usecase';

interface IHandleDTO {
  asset_id: string;
}

interface IHandleResponse {
  data: IBookmarkAsset;
  error: boolean;
  message?: string;
}

interface IVerifyBookmarkAssetUseCase {
  handle(params: IHandleDTO): Promise<IHandleResponse>;
}

export class VerifyBookmarkAssetUseCase implements IVerifyBookmarkAssetUseCase {
  constructor(
    private readonly url: string,
    private readonly http: AxiosInstance,
    private readonly catchIssueUseCase: ICatchIssueUseCase
  ) {}

  async handle({ asset_id }: IHandleDTO): Promise<IHandleResponse> {
    try {
      const { data } = await this.http.get<IBookmarkAsset>(
        `${this.url}/${asset_id}`
      );

      return {
        data,
        error: false,
      };
    } catch (error) {
      this.catchIssueUseCase.handle({
        error,
        errorName: 'VerifyBookmarkAssetUseCase',
      });

      return {
        data: {} as IBookmarkAsset,
        error: true,
        message:
          'Não foi possível favoritar o fundo, tente novamente mais tarde',
      };
    }
  }
}
